export const customHostnamesRoute = '/admin/custom-hostnames';
export const customHostnamesCreateRoute = `${customHostnamesRoute}/create`;
export const customHostnamesDeleteRoute = `${customHostnamesRoute}/:hostname/delete`;
export const customHostnamesUpdateRoute = `${customHostnamesRoute}/:hostname/update`;
export const customHostnamesRecordsRoute = `${customHostnamesRoute}/:hostname/records`;
